'use strict'

module.exports = typeof window !== 'undefined' && window



// WEBPACK FOOTER //
// ./src/coreUtils/src/main/core/windowGlobal.js